import { patientOverviewItemsPath } from '../../camel/patients/overviewItems'
import { camelQueryKey } from '../camelQuery'

export const patientOverviewItemsQueryKey = (patientUuid: string) =>
  camelQueryKey(patientOverviewItemsPath(patientUuid))
